import React, { useEffect, useState } from "react";
import Counter from "./Counter";
import preview from "../../assets/images/datos1.jpg";
import previewMobile from "../../assets/images/datos1.jpg";
import axios, { AxiosResponse } from "axios";
import { appSettings } from "../endpoints";
import { Counters } from "../../models/counters.model";
//Para su uso en produccion como primera version se retiró la animación hasta corregirla
const Home = () => {
  const [API_URL, setApiURL] = useState("");
  const [Counters, setCounters] = useState<Counters>({
    recibidos: 0,
    resueltos: 0,
    instruccion: 0});
  useEffect(() => {
    appSettings.then((res) => {
      setApiURL(res.API_URL);
    });
  }, []);

  useEffect(() => {
    if (API_URL === '') return;

    GetCounters();
  }, [API_URL]);

  //#region Services
  async function GetCounters() {
    await axios
      .get(`${API_URL}/Estadistica/Counters`)
      .then((res: AxiosResponse<Counters>) => {
        setCounters({
          recibidos: res.data.recibidos,
          resueltos: res.data.resueltos,
          instruccion: res.data.instruccion});
      });
  }
  //#endregion Services

  return (
    <div>
      <h2 className="sectionTitle">Información general</h2>
      <h3 style={{ textAlign: "center" }}>Asuntos</h3>
      <div className="infoRelevante">
        <div
          style={{
            marginTop: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          className="countersWrapper"
        >
          <Counter total={Counters.recibidos} label={"Recibidos"} />
          <Counter total={Counters.resueltos} label={"Resueltos"} />
          <Counter total={Counters.instruccion} label={"En instrucción"} />
        </div>
        <div
          className="imgWebWrapper"
          style={{
            backgroundImage: `url(${preview})`,
            minHeight: 400,
            backgroundAttachment: "fixed",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        ></div>

        <div
          style={{
            backgroundColor: "#24135f",
            color: "white",
            height: "100px",
            fontSize: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          
        </div>
      </div>
    </div>
  );
};

export default Home;
